import React from "react";
import List from "@commonComponents/List";
import ContainerTabForm from "@EUForms/containerTabForm";
import { containerTabActions } from "../../reducer/containerSlice";
import RepeatableSealNumber from "@EUForms/containers/repeatableSealNumber";

const ContainerDetails = ({ dataSource, ...rest }) => {

  const renderItem = (item) => <ContainerTabForm
    key={item.id}
    dataSource={{
      ...item,
      sealNumber: item?.sealsList?.slice(-1)[0]?.sealNumber || ''
    }}
    repeatableSealNumber={<RepeatableSealNumber
      disabled={rest.disabled}
      containerId={item?.id}
      sealsList={item?.sealsList}
      containerTabActions={containerTabActions}
    />}
    {...rest}
  />
  return <List className="responsiveGridCss" dataSource={dataSource} renderItem={renderItem} />

}

export default ContainerDetails